import Heading from '../../ui/Heading';
import Button from '../../ui/Button';
import Overlay from '../../ui/Overlay';
import { useRef, useEffect } from 'react';
import Feedbackclose from '../../assets/icons/Feedbackclose';
import Loader from '../../ui/Loader';
import ButtonNew from '../../ui/ButtonNew';

function TermsAndConditionModal({ close, onSubmit, loading }) {
    const myRef = useRef(null);

    useEffect(() => {
        // Disable scrolling on the body when the modal is open
        document.body.style.overflow = 'hidden';

        function handleClickOutside(event) {
            if (myRef.current && !myRef.current.contains(event.target)) {
                close();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            // Re-enable scrolling when the modal is closed
            document.body.style.overflow = 'unset';
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [close]);

    return (
        <div className="fixed inset-0 w-full h-full bg-[rgb(0,0,0,0.3)] backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
            <div
                ref={myRef}
                className="bg-grayBgNormal rounded-lg max-w-3xl max-h-[90vh] w-full shadow-lg"
            >
                <div className="p-8">
                    <div>
                        <ButtonNew
                            onClick={close}
                            variant="closeNeutral"
                            size="xs"
                            shape="oval"
                            className="absolute top-3 right-4 !p-0"
                            fixedMinWidth
                            minWidthClass="min-w-[2.5rem]"
                        >
                            <Feedbackclose />
                        </ButtonNew>

                    </div>

                    <Heading type="small" className="text-textPrimary font-bold mb-1">Terms and Conditions</Heading>
                    <p className="text-sm text-textSecondary mb-6 border-b border-borderUnderline pb-2">Last updated on 7th of June 2025</p>

                    <div className="overflow-y-auto max-h-[60vh] pr-4 text-textPrimary main">
                        <p className="mb-6">
                            By creating a bounty on the Impact Foundry, you (the "Bounty Master") agree to the following
                            terms and conditions. These rules ensure the integrity, legality, and positive impact of all activities
                            facilitated through the Atlantis ecosystem. Please read carefully before proceeding.
                        </p>

                        <div className="mb-4">
                            <p className="font-semibold mb-1">1. Compliance with Legal and Ethical Standards</p>
                            <p className="mb-2">Bounties must not involve activities that are illegal, unethical, harmful, or otherwise violate the laws
                                of the jurisdiction(s) in which they are conducted.</p>
                            <p>Bounty Masters are solely responsible for ensuring that their bounty content and requirements
                                comply with all relevant local, national, and international laws.</p>
                        </div>

                        <div className="mb-4">
                            <p className="font-semibold mb-1">2. Organizational Accountability</p>
                            <p className="mb-2">All bounties must align with the mission and principles of the organization under which they are
                                created.</p>
                            <p>The organization under which a bounty is published is fully responsible for ensuring that the
                                bounty adheres to legal, ethical, and regulatory standards.</p>
                        </div>

                        <div className="mb-4">
                            <p className="font-semibold mb-1">3. Atlantis Mod Team Oversight</p>
                            <p>The Atlantis Mod Team reserves the right to review and monitor bounties/activities at any time, including after publication.</p>
                        </div>

                        <div className="mb-4">
                            <p className="font-semibold mb-1">4. Prohibited Activities</p>
                            <p className="mb-2">The following activities (non-exhaustive list) are strictly prohibited in any bounty:</p>
                            <ul className="list-disc ml-6 mb-2">
                                <li>Promoting or facilitating violence, exploitation, or discrimination.</li>
                                <li>Encouraging illegal or harmful actions, including environmental damage.</li>
                                <li>Disseminating false or misleading information.</li>
                                <li>Soliciting personal data or funds in a manner deemed exploitative or fraudulent.</li>
                            </ul>
                        </div>

                        <div className="mb-4">
                            <p className="font-semibold mb-1">5. Flagging and Suspension</p>
                            <p className="mb-2">The Atlantis Mod Team reserves the right to flag, suspend, or remove any bounty/activities that is deemed:</p>
                            <ul className="list-disc ml-6 mb-2">
                                <li>Illegal, harmful, or unethical.</li>
                                <li>In violation of the terms outlined in this agreement.</li>
                                <li>Misaligned with the core values of Atlantis.</li>
                            </ul>
                        </div>

                        <div className="mb-4">
                            <p className="font-semibold mb-1">6. Transparency and Documentation</p>
                            <p className="mb-2">Bounty Masters must provide clear, detailed, and transparent instructions for participants.</p>
                            <p>Any supporting materials, documentation, or evidence provided in the bounty must be truthful and verifiable.</p>
                        </div>

                        <div className="mb-4">
                            <p className="font-semibold mb-1">7. Atlantis's Liability and Rights</p>
                            <p className="mb-2">Atlantis is not liable for the actions or outcomes of bounties/activities created by Bounty Masters or organizations.</p>
                            <p>Atlantis reserves the right to update these terms and conditions at any time.</p>
                        </div>

                        <div className="mb-4">
                            <p className="font-semibold mb-1">8. Agreement and Acknowledgment</p>
                            <p className="mb-2">By creating a bounty, you confirm that you have read, understood, and agreed to these terms and conditions.</p>
                            <p>You acknowledge that failure to comply with these terms may result in suspension or termination of your account, organization, or bounties/activities.</p>
                        </div>
                    </div>

                    <div className="flex gap-4 mt-6">

                        <ButtonNew
                            type="button"
                            fixedMinWidth={true}
                            variant="blue"
                            size="sm"
                            onClick={onSubmit}
                        >
                            {loading ? <Loader /> : 'I Agree'}
                        </ButtonNew>
                        <ButtonNew
                            type="button"
                            fixedMinWidth={true}
                            variant="neutral"
                            size="sm"
                            onClick={close}
                        >
                            Cancel
                        </ButtonNew>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsAndConditionModal;